<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageMealPlans.title') }}
    </portal>
    <template v-if="mealPlans !== null">
      <card :title="$t('admin.pageMealPlans.card.mealPlans')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <template v-for="mealPlan in mealPlans" v-if="!mealPlan.deleted">
              <hm-card-inner-line :title="getName(mealPlan)" :clickable="true" :key="mealPlan.id" @click="routeToMealPlan(mealPlan)" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedMealPlans)" :title="$t('admin.pageMealPlans.card.deletedMealPlans')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="mealPlan in deletedMealPlans"
                              :title="getName(mealPlan)"
                              :clickable="true"
                              :key="mealPlan.id"
                              @click="routeToMealPlan(mealPlan)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageMealPlans.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageMealPlans.actions.addMealPlan')" icon="plus" color="blue" @click="addMealPlan()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageMealPlans',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      mealPlans: null,
    };
  },

  computed: {
    deletedMealPlans: function () {
      return isNil(this.mealPlans) ? null : this.mealPlans.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.mealPlan.list(this))
        .then((response) => {
          this.mealPlans = sortBy(response.data.data, ['sort', 'mealPlanType', `name.${this.hotelSettings.details.primaryLanguage}`]);

          this.$serviceBus.$emit('mealPlan.list', this.mealPlans);
        });
    },
    addMealPlan() {
      this.axios.post(this.serviceUrls.mealPlan.list(this), {
        name: {
          [this.hotelSettings.details.primaryLanguage]: this.$t('admin.pageMealPlans.newMealPlanName'),
        },
        description: {
          [this.hotelSettings.details.primaryLanguage]: '',
        },
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(mealPlan) {
      const name = isNil(mealPlan) ? null : mealPlan.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      let details = '';

      if (mealPlan.deleted === false) {
        if (!isNil(mealPlan.amount) && mealPlan.amount !== 0) {
          details += `, ${mealPlan.amount.toLocaleString(this.$i18n.locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${mealPlan.percentage === true ? '%' : this.hotelSettings.details.currency}`;
        }

        if (mealPlan.rateMode === 'PerPerson') {
          details += ` ${this.$t('RateMode.PerPerson')}`;
        }

        if (mealPlan.rateFrequency === 'PerNight') {
          details += ` ${this.$t('RateFrequency.PerNight')}`;
        }
      }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeToMealPlan(mealPlan) {
      this.$router.push({
        name: 'mealPlan',
        params: {
          mealPlanId: mealPlan.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageMealPlans.vue